<template>
  <q-drawer
    v-model="isDrawerOpen"
    side="right"
    bordered
    :width="drawerWidth"
    :breakpoint="600"
    class="notification-drawer"
    :class="{ minimized: !isDrawerOpen }"
    overlay
  >
    <section class="drawer-header flex items-center border-bottom q-pa-md">
      <q-btn
        outline
        round
        dense
        icon="chevron_right"
        color="secondary"
        class="back-btn shadow-btn absolute-top-left bg-white"
        @click="setDrawerOpen(false)"
      />
      <div class="flex items-center">
        <q-icon name="notifications" size="24px" color="primary" class="q-mx-sm" />
        <h6 class="q-my-none text-16 text-primary">Notifications</h6>
      </div>
      <div class="q-ml-auto">
        <q-btn
          v-if="hasNotifications"
          flat
          dense
          color="secondary"
          label="Clear All"
          no-caps
          class="text-12"
          @click="clearAllNotifications"
        />
      </div>
    </section>

    <div class="notifications-container q-pa-md">
      <notification-list />
      <div v-if="!hasNotifications" class="empty-state flex column flex-center q-py-xl">
        <q-icon name="notifications_none" size="48px" color="secondary" class="q-mb-md" />
        <p class="text-14 text-secondary text-center">No notifications</p>
      </div>
    </div>
  </q-drawer>
</template>

<script setup>
import { useConfirmUpdate } from 'src/composables/app/useConfirmUpdate'

import NotificationList from 'src/components/common/NotificationList.vue'

const { hasNotifications, clearAllNotifications, isDrawerOpen, setDrawerOpen } = useConfirmUpdate()

const drawerWidth = 350
</script>

<style lang="scss">
@import 'src/css/setup/_variables.scss';
.q-drawer {
  box-shadow: -2px 0 3px 3px rgba(19, 0, 71, 0.051) !important;
}

.notification-drawer {
  z-index: 10000;
  border-left: 1px solid $clr-border;

  .drawer-header {
    height: $header-height;
    border-bottom: 1px solid $clr-border;

    .back-btn {
      box-shadow: $btn-shadow;
      transform: translate(-50%, 47%);
    }
  }

  .notifications-container {
    height: calc(100vh - $header-height * 2);
    overflow-y: auto;
  }

  .empty-state {
    height: 200px;
    opacity: 0.7;
  }

  &.minimized {
    width: auto !important;
    min-width: auto !important;
  }
}
</style>
